import React from 'react';
import MediaItemErrorMsg from './MediaItemErrorMsg.js';
import { initCustomElement, Image as Image$1 } from '@wix/image';
import '../style-inject.es-746bb8ed.js';
import 'classnames';
import 'wix-rich-content-common/libs/Tooltip';
import 'wix-rich-content-common';
import '../Icons/ErrorIcon.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
let wixImageInitialized = false;
const Image = (props) => {
  if (!wixImageInitialized) {
    initCustomElement();
    wixImageInitialized = true;
  }
  const _a = props, { containerProps, error } = _a, imageProps = __objRest(_a, ["containerProps", "error"]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: containerProps == null ? void 0 : containerProps.style,
      id: containerProps == null ? void 0 : containerProps.containerId,
      className: containerProps == null ? void 0 : containerProps.className,
      "data-hook": containerProps == null ? void 0 : containerProps.dataHook
    },
    /* @__PURE__ */ React.createElement(Image$1, __spreadValues({}, imageProps)),
    error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error: error.message, t: error.t })
  );
};

export { Image as default };
//# sourceMappingURL=Image.js.map
